import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { MeDataType, UserRole } from '@/types';

import axiosInstance from '@/lib/axios-instance';
import { API_ROUTES } from '@/lib/routes/api-routes';

const selectRole = async (role: UserRole) => {
  const { data } = await axiosInstance.patch(API_ROUTES.users.selectRole, { role });

  return data;
};

const useSelectRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: selectRole,

    onSuccess: (data: MeDataType) => {
      queryClient.setQueryData(['me'], data);
    },
  });
};

export default useSelectRole;
